import * as React from 'react';
import * as _ from 'lodash';
import dialogLoader from '../../utilities/dialogLoader';
import ReactDropDownCalender from '../../components/ReactDropDownCalender';
import { START_END_TIME, SPOT_STATUS } from '../../utilities/constants';
import ReportNames from '../../utilities/reportNames';
import { FieldTreePartnerCompanyDropdown } from '../../components/dropdowns/single/FieldTreePartnerCompanyDropdown';
import { FieldTreeUserListDropdown } from '../../components/dropdowns/single/FieldTreeUserList';
import { messageUtility } from '../../utilities/messageUtility';

/**
 * ゲート予定帳票
 */
export const GatePassageDocuments = ({ show, calling, callbacks }) => (
  <div id='modal-dialog-document' className={show ? 'modal show' : 'modal'}>
    <div className='dialog-sm dialog--modal'>
      <div className='dialog-sm__header'>
        <span className='dialog-sm__title'>
          {calling ? '通信中です' : '帳票選択'}
        </span>
      </div>
      <div className='dialog-sm__footer'>
        <button
          className='btn-fixedsize--sub'
          onClick={() => callbacks.print.dailyGatePassage()}
        >
          車輛一覧（日次）
        </button>
        <button
          className='btn-fixedsize--sub'
          onClick={() => callbacks.print.weeklyGatePassage()}
        >
          車輛一覧（週間）
        </button>
        <button
          className='btn--font-md--sub'
          onClick={() => callbacks.print.monthlyGatePassage()}
        >
          車輛搬出入予定月間集計表
        </button>
        <button
          id='modal-close-document'
          className='btn-fixedsize--sub'
          onClick={() => callbacks.handleVisible('documents')}
        >
          戻る
        </button>
      </div>
    </div>
  </div>
);

/**
 * 揚重機予定帳票
 */
export const CraneUseDocuments = ({ show, calling, callbacks }) => (
  <div id='modal-dialog-document' className={show ? 'modal show' : 'modal'}>
    <div className='dialog-sm dialog--modal'>
      <div className='dialog-sm__header'>
        <span className='dialog-sm__title'>
          {calling ? '通信中です' : '帳票選択'}
        </span>
      </div>
      <div className='dialog-sm__footer'>
        <button
          className='btn-fixedsize--sub'
          onClick={() => callbacks.print.craneUses()}
        >
          揚重作業計画・作業指示書
        </button>
        <button
          className='btn-fixedsize--sub'
          onClick={() => callbacks.print.weeklyCraneUse()}
        >
          揚重予定一覧（週間）
        </button>
        <button
          className='btn--font-md--sub'
          onClick={() => callbacks.print.monthlyCraneUse()}
        >
          揚重予定月間集計表
        </button>
        <button
          id='modal-close-document'
          className='btn-fixedsize--sub'
          onClick={() => callbacks.handleVisible('documents')}
        >
          戻る
        </button>
      </div>
    </div>
  </div>
);

/**
 * 機材予定帳票
 */
export const MachineryUseDocuments = ({ show, calling, callbacks }) => (
  <div id='modal-dialog-document' className={show ? 'modal show' : 'modal'}>
    <div className='dialog-sm dialog--modal'>
      <div className='dialog-sm__header'>
        <span className='dialog-sm__title'>
          {calling ? '通信中です' : '帳票選択'}
        </span>
      </div>
      <div className='dialog-sm__footer'>
        <button className='btn--font-md--sub' onClick={() => callbacks.print()}>
          計画・作業指示書
        </button>
        <button
          id='modal-close-document'
          className='btn-fixedsize--sub'
          onClick={() => callbacks.handleVisible('documents')}
        >
          戻る
        </button>
      </div>
    </div>
  </div>
);

export const DeleteModal = ({ show, fieldItem, data, modal }) => (
  <div
    id='modal-dialog-confirm-selected'
    className={show ? 'modal show' : 'modal'}
  >
    <div className='dialog-md dialog--modal'>
      <div className='dialog-md__header'>
        <span className='dialog-md__title'>データの削除</span>
      </div>
      <div className='dialog-md__body text-center'>
        データを削除します。この操作は取り消せません。
      </div>
      <div className='dialog-md__footer-horizontal'>
        <button
          id='modal-close-confirm-selected'
          className='btn-fixedsize--sub'
          onClick={() => modal.deleteModal(fieldItem)}
        >
          戻る
        </button>
        <button
          className='btn-fixedsize--negative'
          onClick={() => data.deleteItemData(fieldItem)}
        >
          削除
        </button>
      </div>
    </div>
  </div>
);

export class Delete extends React.Component {
  render() {
    return (
      <div id='modal-dialog-delete' className='modal show'>
        <div className='dialog-md dialog--modal'>
          <div className='dialog-md__header'>
            <span className='dialog-md__title'>データの削除</span>
          </div>
          <div className='dialog-md__body text-center'>
            データを削除します。この操作は取り消せません。
          </div>
          <div className='dialog-md__footer-horizontal'>
            <button
              id='modal-close-delete'
              className='btn-fixedsize--sub'
              onClick={() => {
                dialogLoader.close();
              }}
            >
              戻る
            </button>
            <button
              id='modal-submit-delete'
              className='btn-fixedsize--negative'
              onClick={() =>
                this.props.dialog.state.callbacks.modal.delete(
                  this.props.dialog.state.deleteId
                )
              }
            >
              削除
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export const LatestCopy = ({ show, callbacks }) => (
  <div id='modal-dialog-copy' className={show ? 'modal show' : 'modal'}>
    <div className='dialog-md dialog--modal'>
      <div className='dialog-md__header'>
        <span className='dialog-md__title'>前回登録した内容をコピー</span>
      </div>
      <div className='dialog-md__body text-center'>
        現在編集中のデータを上書きします。よろしいですか？
        ※この操作は取り消せません。
      </div>
      <div className='dialog-md__footer-horizontal'>
        <button
          id='modal-close-copy'
          className='btn--sm--sub'
          onClick={() => callbacks.handleVisible('copy')}
        >
          戻る
        </button>
        <button
          id='modal-submit-copy'
          className='btn--sm--effective'
          onClick={callbacks.copy}
        >
          コピーする
        </button>
      </div>
    </div>
  </div>
);

export const Edited = () => (
  <div id='modal-dialog-confirm-selected' className='modal show'>
    <div className='dialog-sm dialog--modal'>
      <div className='dialog-sm__header'>
        <span className='dialog-sm__title'>更新完了</span>
      </div>
      <div className='dialog-sm__footer'>
        <button
          id='modal-close-confirm-selected'
          className='btn-fixedsize--sub'
          onClick={() => {
            dialogLoader.close();
          }}
        >
          了解
        </button>
      </div>
    </div>
  </div>
);

export const EditDestroy = () => (
  <div id='modal-dialog-confirm-selected' className='modal show'>
    <div className='dialog-sm dialog--modal'>
      <div className='dialog-sm__header'>
        <span className='dialog-sm__title'>
          禁止時間帯設定を
          <br /> 解除しました。
        </span>
      </div>
      <div className='dialog-sm__footer'>
        <button
          id='modal-close-confirm-selected'
          className='btn-fixedsize--sub'
          onClick={() => {
            dialogLoader.close();
          }}
        >
          了解
        </button>
      </div>
    </div>
  </div>
);

export const EditSuccess = () => (
  <div id='modal-dialog-confirm-selected' className='modal show'>
    <div className='dialog-sm dialog--modal'>
      <div className='dialog-sm__header'>
        <span className='dialog-sm__title'>更新を正常に完了しました。</span>
      </div>
      <div className='dialog-sm__footer'>
        <button
          id='modal-close-confirm-selected'
          className='btn-fixedsize--sub'
          onClick={() => {
            dialogLoader.close();
          }}
        >
          了解
        </button>
      </div>
    </div>
  </div>
);

export class DuplicateDialog extends React.Component {
  render() {
    return (
      <div className='dialog-md dialog--modal'>
        <div className='dialog-md__body text-center'>
          {messageUtility.getMessage('E-000-030')}
        </div>
        <div className='dialog-md__footer-horizontal'>
          <button
            id='modal-close-copy'
            className='btn--sm--sub'
            onClick={() => {
              this.props.dialog.callback.redoit();
            }}
          >
            確認
          </button>
        </div>
      </div>
    );
  }
}

export class DuplicateDialogPersonal extends React.Component {
  render() {
    return (
      <div className='dialog-md dialog--modal'>
        <div className='dialog-md__body text-center'>
          {messageUtility.getMessage('E-000-031')}
        </div>
        <div className='dialog-md__footer-horizontal'>
          <button
            id='modal-close-copy'
            className='btn--sm--sub'
            onClick={() => {
              this.props.dialog.callback.redoit_personal();
            }}
          >
            確認
          </button>
        </div>
      </div>
    );
  }
}

/**
 * 入退場実績登録
 * @param show {bool}
 * @param isSpot {bool}
 * @param checkInOuts {array} 履歴
 */
export const PerformanceRegister = ({
  show,
  isSpot,
  checkInOuts,
  callbacks,
}) => (
  <div id='modal-dialog-disable-time' className={show ? 'modal show' : 'modal'}>
    <div className='dialog-md dialog--modal'>
      <div className='dialog-md__header'>
        <span className='dialog-md__title'>入退場実績登録</span>
      </div>
      <div className='entrance-exit-dialog-md__body'>
        <table className='entrance-exit-dialog-form'>
          <tbody>
            <tr style={isSpot ? { display: 'none' } : { display: 'table-row' }}>
              <td className='entrance-exit-dialog-form__label'>
                <span className='label'>協力会社</span>
              </td>
              <td className='entrance-exit-dialog-form__element'>
                <FieldTreePartnerCompanyDropdown
                  value={checkInOuts.field_tree_id}
                  set={callbacks.setFlatLog}
                />
                <button
                  id='btn-uncheck-all'
                  className='btn-text entrance-exit-spot'
                  onClick={() => callbacks.setSpot(SPOT_STATUS.spot.id)}
                >
                  スポット業者登録
                </button>
              </td>
            </tr>
            <tr style={isSpot ? { display: 'none' } : { display: 'table-row' }}>
              <td className='entrance-exit-dialog-form__label'>
                <span className='label'>作業員</span>
              </td>
              <td className='entrance-exit-dialog-form__element'>
                <FieldTreeUserListDropdown
                  value={checkInOuts.user_id}
                  fieldTreeId={checkInOuts.field_tree_id}
                  set={callbacks.setFlatLog}
                />
              </td>
            </tr>
            <tr style={isSpot ? { display: 'table-row' } : { display: 'none' }}>
              <td className='entrance-exit-dialog-form__label'>
                <span className='label'>協力会社</span>
              </td>
              <td className='entrance-exit-dialog-form__element'>
                <input
                  type='text'
                  value={checkInOuts.spot_company_name}
                  placeholder='会社名を入力'
                  onChange={e =>
                    callbacks.setFlatLog('spot_company_name', e.target.value)
                  }
                />
                <button
                  id='btn-uncheck-all'
                  className='btn-text entrance-exit-spot'
                  onClick={() => callbacks.setSpot(SPOT_STATUS.normal.id)}
                >
                  戻る
                </button>
              </td>
            </tr>
            <tr style={isSpot ? { display: 'table-row' } : { display: 'none' }}>
              <td className='entrance-exit-dialog-form__label'>
                <span className='label'>作業員</span>
              </td>
              <td className='entrance-exit-dialog-form__element'>
                <input
                  type='text'
                  value={checkInOuts.spot_worker_name}
                  placeholder='作業員名を入力'
                  onChange={e =>
                    callbacks.setFlatLog('spot_worker_name', e.target.value)
                  }
                />
              </td>
            </tr>
            {_.map(checkInOuts.logs, (log, index) => (
              <LogLine
                key={index}
                foreignKey={index}
                log={log}
                callbacks={callbacks}
              />
            ))}
          </tbody>
        </table>
        <button className='btn-text--sm' onClick={() => callbacks.add()}>
          <i className='vertical-middle' />
          +入退場データを追加する
        </button>
      </div>
      <div className='entrance-exit-dialog-form__footer'>
        <button
          id='modal-close-disable-time'
          className='btn--sub'
          onClick={() => callbacks.handleVisible('register')}
        >
          戻る
        </button>
        <button className='btn' onClick={() => callbacks.submit()}>
          登録
        </button>
      </div>
    </div>
  </div>
);

/**
 * 入退場実績登録
 * @param foreignKey {int}
 * @param log {array}
 */
export const LogLine = ({ foreignKey, log, callbacks }) => (
  <tr>
    <td className='entrance-exit-dialog-form__label'>
      <select disabled value={log.in_out_flag} style={{ color: '#7C7C7C' }}>
        <option value='1' selected={foreignKey % 2 == 0 ? true : false}>
          入場
        </option>
        <option value='2' selected={foreignKey % 2 != 0 ? true : false}>
          退場
        </option>
      </select>
    </td>
    <td className='entrance-exit-dialog-form__element'>
      <ReactDropDownCalender
        onChange={date => callbacks.set(date, 'in_out_date', foreignKey)}
        value={log.in_out_date}
      />
    </td>
    <td className='entrance-exit-dialog-form__element'>
      <select
        value={log.in_out_time}
        onChange={e => callbacks.set(e.target.value, 'in_out_time', foreignKey)}
      >
        {_.map(START_END_TIME, time => (
          <option key={time.id} value={time.id}>
            {time.name}
          </option>
        ))}
      </select>
    </td>
    <td className='entrance-exit-dialog-form__element'>
      <button
        style={foreignKey == 0 ? { display: 'none' } : { display: 'initial' }}
        className='btn-form-item-delete'
        onClick={() => callbacks.remove(foreignKey)}
      >
        <i className='i-close i-3x' />
      </button>
    </td>
  </tr>
);

/**
 * 入退場実績編集
 * @param show {bool}
 * @param checkInOuts {array} 履歴
 */
export const PerformanceEdit = ({ show, checkInOuts, callbacks }) => (
  <div id='modal-dialog-disable-time' className={show ? 'modal show' : 'modal'}>
    <div className='dialog dialog--modal'>
      <div className='dialog__header'>
        <span className='dialog__title'>入退場実績編集</span>
      </div>
      <div className='entrance-exit-dialog-md__body'>
        <table className='entrance-exit-dialog-form'>
          <tbody>
            <tr>
              <td className='entrance-exit-dialog-form__label'>
                <span className='label'>作業員</span>
              </td>
              <td className='entrance-exit-dialog-form__element'>
                <input disabled type='text' value={checkInOuts.user_name} />
              </td>
            </tr>
            {_.map(checkInOuts.logs, (log, index) => (
              <EditLogLine
                key={index}
                foreignKey={index}
                log={log}
                callbacks={callbacks}
              />
            ))}
          </tbody>
        </table>
        <button className='btn-text--sm' onClick={() => callbacks.add()}>
          <i className='vertical-middle' />
          +入退場データを追加する
        </button>
      </div>
      <div className='entrance-exit-dialog-form__footer'>
        <button
          id='modal-close-disable-time'
          className='btn--sub'
          onClick={() => callbacks.handleVisible('edit')}
        >
          戻る
        </button>
        <button className='btn' onClick={() => callbacks.update()}>
          更新
        </button>
      </div>
    </div>
  </div>
);

/**
 * 入退場実績編集
 * @param foreignKey {int}
 * @param log {array}
 */
export const EditLogLine = ({ foreignKey, log, callbacks }) => (
  <tr>
    <td className='entrance-exit-dialog-form__label'>
      <select disabled value={log.in_out_flag} style={{ color: '#7C7C7C' }}>
        <option value='1' selected={foreignKey % 2 == 0 ? true : false}>
          入場
        </option>
        <option value='2' selected={foreignKey % 2 != 0 ? true : false}>
          退場
        </option>
      </select>
    </td>
    <td className='entrance-exit-dialog-form__element'>
      <ReactDropDownCalender
        onChange={date => callbacks.set(date, 'in_out_date', foreignKey)}
        value={log.in_out_date}
      />
    </td>
    <td className='entrance-exit-dialog-form__element'>
      <select
        value={log.in_out_time}
        onChange={e => callbacks.set(e.target.value, 'in_out_time', foreignKey)}
      >
        {_.map(START_END_TIME, time => (
          <option key={time.id} value={time.id}>
            {time.name}
          </option>
        ))}
      </select>
    </td>
    <td className='entrance-exit-dialog-form__element'>
      <button
        style={foreignKey == 0 ? { display: 'none' } : { display: 'initial' }}
        className='btn-form-item-delete'
        onClick={() => callbacks.remove(foreignKey)}
      >
        <i className='i-close i-3x' />
      </button>
    </td>
  </tr>
);

/**
 * CCUS入退場実績登録
 * @param show {bool}
 * @param isSpot {bool}
 * @param checkInOuts {array} 履歴
 */
export const CcusPerformanceRegister = ({
  show,
  // eslint-disable-next-line no-unused-vars
  isSpot,
  checkInOuts,
  callbacks,
}) => (
  <div id='modal-dialog-disable-time' className={show ? 'modal show' : 'modal'}>
    <div className='dialog-md dialog--modal'>
      <div className='dialog-md__header'>
        <span className='dialog-md__title'>入退場実績登録CCUS</span>
      </div>
      <div className='entrance-exit-dialog-md__body'>
        <table className='entrance-exit-dialog-form'>
          <tbody>
            <tr colSpan='2'>
              <td className='entrance-exit-dialog-form__label'>
                <span className='label'>協力会社</span>
              </td>
              <td className='entrance-exit-dialog-form__element'>
                <FieldTreePartnerCompanyDropdown
                  value={checkInOuts.field_tree_id}
                  set={callbacks.setFlatLog}
                />
              </td>
            </tr>
            <tr colSpan='2'>
              <td className='entrance-exit-dialog-form__label'>
                <span className='label'>作業員</span>
              </td>
              <td className='entrance-exit-dialog-form__element'>
                <FieldTreeUserListDropdown
                  value={checkInOuts.user_id}
                  fieldTreeId={checkInOuts.field_tree_id}
                  set={callbacks.setFlatLog}
                />
              </td>
            </tr>
            {_.map(checkInOuts.logs, (log, index) => (
              <CcusLogLine
                key={index}
                foreignKey={index}
                log={log}
                callbacks={callbacks}
              />
            ))}
          </tbody>
        </table>
        <button className='btn-text--sm' onClick={() => callbacks.add()}>
          <i className='vertical-middle' />
          +入退場データを追加する
        </button>
      </div>
      <div className='entrance-exit-dialog-form__footer'>
        <button
          id='modal-close-disable-time'
          className='btn--sub'
          onClick={() => callbacks.handleVisible('register_ccus')}
        >
          戻る
        </button>
        <button className='btn' onClick={() => callbacks.submit()}>
          登録
        </button>
      </div>
    </div>
  </div>
);

/**
 * CCUS入退場実績登録
 * @param foreignKey {int}
 * @param log {array}
 */
export const CcusLogLine = ({ foreignKey, log, callbacks }) => (
  <tr>
    <td className='entrance-exit-dialog-form__label'>
      <select disabled value={log.in_out_flag} style={{ color: '#7C7C7C' }}>
        <option value='1' selected={foreignKey % 2 == 0 ? true : false}>
          入場
        </option>
        <option value='2' selected={foreignKey % 2 != 0 ? true : false}>
          退場
        </option>
      </select>
    </td>
    <td className='entrance-exit-dialog-form__element'>
      <ReactDropDownCalender
        onChange={date => callbacks.set(date, 'in_out_date', foreignKey)}
        value={log.in_out_date}
      />
    </td>
    <td className='entrance-exit-dialog-form__element'>
      <select
        value={log.in_out_time}
        onChange={e => callbacks.set(e.target.value, 'in_out_time', foreignKey)}
      >
        {_.map(START_END_TIME, time => (
          <option key={time.id} value={time.id}>
            {time.name}
          </option>
        ))}
      </select>
    </td>
    <td className='entrance-exit-dialog-form__element'>
      <button
        style={foreignKey == 0 ? { display: 'none' } : { display: 'initial' }}
        className='btn-form-item-delete'
        onClick={() => callbacks.remove(foreignKey)}
      >
        <i className='i-close i-3x' />
      </button>
    </td>
  </tr>
);

/**
 * CCUS入退場実績編集
 * @param show {bool}
 * @param checkInOuts {array} 履歴
 */
export const CcusPerformanceEdit = ({ show, checkInOuts, callbacks }) => (
  <div id='modal-dialog-disable-time' className={show ? 'modal show' : 'modal'}>
    <div className='dialog-md dialog--modal'>
      <div className='dialog-md__header'>
        <span className='dialog-md__title'>入退場実績編集</span>
      </div>
      <div className='entrance-exit-dialog-md__body'>
        <table className='entrance-exit-dialog-form'>
          <tbody>
            <tr style={{ display: 'table-row' }}>
              <td className='entrance-exit-dialog-form__label'>
                <span className='label'>協力会社</span>
              </td>
              <td colSpan='2' className='entrance-exit-dialog-form__element'>
                <input disabled type='text' value={'協力会社名'} />
              </td>
            </tr>
            <tr style={{ display: 'table-row' }}>
              <td className='entrance-exit-dialog-form__label'>
                <span className='label'>作業員</span>
              </td>
              <td colSpan='2' className='entrance-exit-dialog-form__element'>
                <input disabled type='text' value={checkInOuts.user_name} />
              </td>
            </tr>
            {_.map(checkInOuts.logs, (log, index) => (
              <CcusEditLogLine
                key={index}
                foreignKey={index}
                log={log}
                callbacks={callbacks}
              />
            ))}
          </tbody>
        </table>
        <button className='btn-text--sm' onClick={() => callbacks.add()}>
          <i className='vertical-middle' />
          +入退場データを追加する
        </button>
      </div>
      <div className='entrance-exit-dialog-form__footer'>
        <button
          id='modal-close-disable-time'
          className='btn--sub'
          onClick={() => callbacks.handleVisible('edit_ccus')}
        >
          戻る
        </button>
        <button className='btn' onClick={() => callbacks.update()}>
          更新
        </button>
      </div>
    </div>
  </div>
);

/**
 * CCUS入退場実績編集
 * @param foreignKey {int}
 * @param log {array}
 */
export const CcusEditLogLine = ({ foreignKey, log, callbacks }) => (
  <tr>
    <td className='entrance-exit-dialog-form__label'>
      <select disabled value={log.in_out_flag} style={{ color: '#7C7C7C' }}>
        <option value='1' selected={foreignKey % 2 == 0 ? true : false}>
          入場
        </option>
        <option value='2' selected={foreignKey % 2 != 0 ? true : false}>
          退場
        </option>
      </select>
    </td>
    <td className='entrance-exit-dialog-form__element'>
      <ReactDropDownCalender
        onChange={date => callbacks.set(date, 'in_out_date', foreignKey)}
        value={log.in_out_date}
      />
    </td>
    <td className='entrance-exit-dialog-form__element'>
      <select
        value={log.in_out_time}
        onChange={e => callbacks.set(e.target.value, 'in_out_time', foreignKey)}
      >
        {_.map(START_END_TIME, time => (
          <option key={time.id} value={time.id}>
            {time.name}
          </option>
        ))}
      </select>
    </td>
    <td className='entrance-exit-dialog-form__element'>
      <button
        style={foreignKey == 0 ? { display: 'none' } : { display: 'initial' }}
        className='btn-form-item-delete'
        onClick={() => callbacks.remove(foreignKey)}
      >
        <i className='i-close i-3x' />
      </button>
    </td>
  </tr>
);

export class PrintPreview extends React.Component {
  render() {
    return (
      <div id='modal-dialog-confirm-selected' className='modal show'>
        <div className='dialog-sm dialog--modal'>
          <div className='dialog-sm__header'>
            <span className='dialog-sm__title'>帳票プレビュー</span>
          </div>
          <div className='dialog-sm__footer'>
            <button
              className='btn-fixedsize--sub'
              onClick={() => {
                this.props.dialog.state.callbacks.printOutPreview(
                  ReportNames.PrintoutPrev,
                  56
                );
              }}
            >
              作業指示書
            </button>
            <button
              className='btn-fixedsize--sub'
              onClick={() => {
                this.props.dialog.state.callbacks.printOutPreview(
                  ReportNames.PrintoutPrev2,
                  57
                );
              }}
            >
              連絡調整実施記録
            </button>
            <button
              id='modal-close-confirm-selected'
              className='btn-fixedsize--sub'
              onClick={() => {
                dialogLoader.close();
              }}
            >
              戻る
            </button>
          </div>
        </div>
      </div>
    );
  }
}

/**
 * 入退場実績編集 ( 作業員一覧 )
 * @param show {bool}
 * @param checkInOuts {array} 履歴
 */
export const WorkerCommentEdit = ({ show, checkInOuts, callbacks }) => (
  <div id='modal-dialog-disable-time' className={show ? 'modal show' : 'modal'}>
    <div className='dialog-md dialog--modal'>
      <div className='dialog-md__header'>
        <span className='dialog-md__title'>入退場実績編集</span>
      </div>
      <div className='entrance-exit-dialog-md__body'>
        <table className='entrance-exit-dialog-form'>
          <tbody>
            <tr>
              <td className='entrance-exit-dialog-form__label'>
                <span className='label'>作業員</span>
                <input disabled type='text' value={checkInOuts.user_name} />
              </td>
            </tr>
            <tr>
              <td className='entrance-exit-dialog-form__element'>
                <span className='label'>コメント</span>
                <textarea
                  name=''
                  id=''
                  cols='30'
                  rows='10'
                  style={{ width: 300, height: 120 }}
                />
              </td>
            </tr>
          </tbody>
        </table>
        {/* <button
          className="btn-text--sm"
          onClick={()=>callbacks.add()}>
          <i className="vertical-middle"></i>
          +入退場データを追加する</button> */}
      </div>
      <div className='entrance-exit-dialog-form__footer'>
        <button
          id='modal-close-disable-time'
          className='btn--sub'
          onClick={() => callbacks.handleVisible('edit')}
        >
          戻る
        </button>
        <button
          className='btn'
          onClick={() => alert('コメント登録する処理をする。')}
        >
          更新
        </button>
      </div>
    </div>
  </div>
);

export const DialogTitle = props => (
  <div id='modal-dialog-confirm-selected' className='modal show'>
    <div className='dialog-sm-wide dialog--modal'>
      <div className='dialog-sm-wide__header'>
        <span className='dialog-sm-wide__title'>{props.dialog.title}</span>
      </div>
      <div className='dialog-sm-wide__footer'>
        <button
          id='modal-close-confirm-selected'
          className='btn-fixedsize--sub'
          onClick={props.dialog.callbacks}
        >
          {props.dialog.buttonText}
        </button>
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/modals/Commons.jsx